<template>
    <div class="exammanage">
        <div class="header">
            <el-col>
                <el-button type="primary" @click="$router.push('addtestpaper?isNew=0')">试卷添加</el-button>
            </el-col>
            <el-col>
                考试类型：
                <el-checkbox-group v-model="param.examTypes" style="display: inline-block;">
                    <el-checkbox label="1">培训考试</el-checkbox>
                    <el-checkbox label="2">课程考试</el-checkbox>
                    <el-checkbox label="3">章节考试</el-checkbox>
                </el-checkbox-group>

                <el-input v-model="param.searchValue" clearable placeholder="请输入试卷标题、所属培训、所属课程、所属章节查询" style="width: 400px;margin-left: 20px;"></el-input>
                <el-button type="primary" style="margin-left: 20px;" @click="list()">查询</el-button>
                <el-button type="primary" @click="$router.push('/Education/Examstatistics')">考试统计</el-button>
            </el-col>
        </div>

        <div class="exammanageData">
            <el-table
            v-loading="loading"
            :data="exammanageData"
            :cell-style="{'text-align':'center'}"
            style="width: 100%">
                <el-table-column prop="examTitle" label="试卷标题"></el-table-column>
                <el-table-column prop="examRelName" label="所属章节/课程/培训/"></el-table-column>
                <el-table-column prop="examChapterName" label="章节所属课程" :formatter="CreatexamChapterName"></el-table-column>
                <el-table-column prop="examType" label="考试类型"></el-table-column>
                <el-table-column prop="examDuration" label="考试时长"></el-table-column>
                <el-table-column prop="createBy" label="录入人"></el-table-column>
                <el-table-column prop="createTime" sortable label="录入时间"></el-table-column>
                <el-table-column label="操作">
                    <template v-slot="scope">
                        <el-popconfirm 
                        title="是否确认删除？"
                        @confirm="ClickDelete(scope.row)">
                            <span class="manage" slot="reference">删除</span>
                        </el-popconfirm>
                        <span class="manage" @click="$router.push('addtestpaper?isNew=1&examId='+scope.row.examId)">修改</span>
                        <span class="manage" @click="$router.push('addtestpaper?isNew=2&examId='+scope.row.examId)">查看详情</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                hide-on-single-page
                @current-change="handleCurrentChange"
                :current-page.sync="param.pageNum"
                :page-size="param.pageSize"
                layout="total, prev, pager, next"
                :total="param.Total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    export default{
        data() {
            return {
                loading:true,
                exammanageData:[],
                param:{
                    pageNum:1,
                    pageSize:10,
                    searchValue:'',
                    examTypes:[],
                    Total:0
                }
            }
        },
        activated() {
            this.list();
        },
        methods: {
            list(){
                this.loading=true;
                this.$Http_Post('edu/exam/list',this.param).then(res=>{
                    if(res.Code==0){
                        this.exammanageData=res.Data;
                        this.param.Total=res.Counts;
                    }else{
                        this.$message({type: 'error', message:res.Message});
                    }
                    this.loading=false;
                })
            },
            // 分页
            handleCurrentChange(val){
                this.param.pageNum=val;
                this.list();
            },
            // 删除
            ClickDelete(e){
                this.$Http_Post('edu/exam/remove/'+e.examId).then(res=>{
                    if(res.Code==0){
                        this.list();
                        this.$message({type: 'success', message:res.Message});
                    }else{
                        this.$message({type: 'error', message:res.Message});
                    }
                });
            },
            CreatexamChapterName(row){
                return row.examChapterName?row.examChapterName:'--'
            }
        },
    }
</script>
<style scoped>
.header{background: #fff;padding: 20px 30px;margin-bottom: 20px;}
.header::after{content: '';clear: both;display: block;height:0;}
.exammanageData{background: #fff;padding:20px;}
.manage{padding: 0 5px 0 0;color: #409EFF;cursor: pointer;}
</style>